"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var features_1 = require("../features");
var useDisableScroll_1 = require("../../helpers/useDisableScroll");
var Wrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    ", "\n\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    ",
    "\n\n    ",
    "\n"])), function (props) {
    return props.isEmpty && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            height: 100%;\n            overflow: auto;\n        "], ["\n            height: 100%;\n            overflow: auto;\n        "])));
}, function (props) {
    return props.disabled && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            pointer-events: none;\n        "], ["\n            pointer-events: none;\n        "])));
});
exports.gridBoxId = 'grid-box';
var DisabledOverlay = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: transparent;\n    z-index: 9999;\n"], ["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: transparent;\n    z-index: 9999;\n"])));
var GridBox = react_1.forwardRef(function (_a, ref) {
    var children = _a.children, disabled = _a.disabled;
    var isEmpty = features_1.useGridContext().state.isEmpty;
    var innerRef = react_1.useRef(null);
    ref = ref || innerRef;
    useDisableScroll_1.useDisableScroll({
        activate: disabled,
        ref: ref
    });
    return (react_1.default.createElement(Wrapper, { ref: ref, "data-selector-id": exports.gridBoxId, isEmpty: isEmpty, disabled: disabled },
        children,
        disabled && react_1.default.createElement(DisabledOverlay, null)));
});
exports.default = GridBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=GridBox.js.map